module.exports = __webpack_public_path__ + "files/8920362d7deb9b93c5f384c16282747f.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo_compact.png
// module id = 922
// module chunks = 76